import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportDeliveryNoteService extends GenericService {
    constructor() {
        super('/reports/delivery_note', axiosInstance);
    }
}

export default new ReportDeliveryNoteService(); 